<template>
    <div class="slice">
        <div class="slice-content">
            <ProductLogo class="product-footer__logo" :animate="animate" />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import {ref, onMounted} from 'vue';
    import ProductLogo from '~/components/product/ProductLogo.vue';
    import {useGsap} from '@/composables/useGsap';

    const {ScrollTrigger} = useGsap();

    const animate = ref(false);

    onMounted(() => {
        ScrollTrigger.create({
            trigger: '.product-footer__logo',
            start: 'top bottom',
            onEnter: () => (animate.value = true),
            onLeaveBack: () => (animate.value = false),
        });
    });
</script>

<style lang="scss">
    .product-footer__logo {
        display: inline-block;
        color: var(--joy-color-text-body);
        width: 146px;
        margin-left: 73px;
        font-size: var(--joy-font-size-primary-600);
        filter: brightness(0);

        &.animate {
            p {
                transition-delay: 0.5s;
            }
        }
    }
</style>
